var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconDisabled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete Icon",
    d: "M3.86646 27.9997C3.25783 27.998 2.67465 27.7516 2.24428 27.3144C1.81391 26.8772 1.57135 26.2847 1.56958 25.6664V3.49981H0V1.1665H7.19683V0H17.3032V1.16669H24.5V3.5H22.9305V25.6667C22.9157 26.2808 22.669 26.8656 22.2414 27.3C21.8139 27.7344 21.2381 27.985 20.6336 28L3.86646 27.9997ZM20.6338 3.49981H3.86646V25.6664H20.6338V3.49981ZM7.92413 22.322H10.2211V6.80532H7.92413V22.322ZM14.2789 22.322H16.5757V6.80532H14.2787L14.2789 22.322Z",
    fill: "#eeeeee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDisabled);
export default __webpack_public_path__ + "static/media/deleteIconDisabled.0eb776be968b9beee52200eb0492c1e6.svg";
export { ForwardRef as ReactComponent };